require('./style.scss');

import EventEmitter from 'lib/helpers/EventEmmiter';

export default class LanguageSelector extends EventEmitter{
    flags = ['EN', 'FR', 'RO', 'UAE', 'CH', 'ZH', 'BG', 'AR', 'DE', 'ES', 'JA', 'NL', 'PT', 'TH', 'RU', 'TR', 'PL', 'BN', 'HI', 'IT', 'GB', 'SK', 'JO'];
        
    constructor(flags) {
        super(flags);

        this.flags = flags
    }

    showDefaultLanguage(e) {
        const wrapper = e.target;
        const container = document.createElement("div");
        container.className = "select-lang-container";

        const overlay = document.createElement("div");
        overlay.className = "select-lang-overlay";
        container.appendChild(overlay);

        overlay.addEventListener("click", this.onClickOverlay.bind(this, wrapper, container, overlay));

        this.flags.forEach(lang => {
            const langItem = document.createElement("div");
            langItem.className = "select-lang-item";
            langItem.setAttribute("data-value", lang);

            langItem.addEventListener("click", this.onChangeLang.bind(this, wrapper, container));
            container.appendChild(langItem);
        });

        wrapper.appendChild(container);
    }

    onClickOverlay(wrapper, container, overlay) {
        wrapper.removeChild(container);
        overlay.removeEventListener("click", this.onClickOverlay);
    }

    onChangeLang(wrapper, container, e) {
        e.preventDefault();
        e.stopPropagation();

        const countryCode = e.target.dataset.value;
        wrapper.dataset.value = countryCode;
        this._fireEvent("on-change", countryCode);

        this.flags.forEach(lang => {
            const langItem = container.querySelector(`[data-value="${lang}"]`);
            langItem.removeEventListener("click", this.onChangeLang);
        });

        wrapper.removeChild(container);
    }
}
